import {
  type PlanTypeCard,
  SubmissionStatusFilter,
  type SubmissionStatusFilterCounts,
} from '@ebalance/proto/bffuser/v1/submission_management_model_pb'

/**
 * 提出ステータスの絞込 (AC-PSM-070〜074、submission-management.md §8)。
 * 区分は backend が代表の計画から振り分けて `PlanTypeCard.submissionStatusFilter` に
 * 載せる。frontend は選択肢と区分の対応づけだけを持ち、振り分け・件数集計はしない。
 */
export type SubmissionStatusFilterOption =
  | 'all'
  | 'actionRequired'
  | 'unsubmitted'
  | 'waiting'
  | 'submitted'

/** 表示順 (spec §8: すべて / 要対応 / 未提出 / 待ち / 提出済)。 */
export const SUBMISSION_STATUS_FILTER_OPTIONS: readonly SubmissionStatusFilterOption[] =
  ['all', 'actionRequired', 'unsubmitted', 'waiting', 'submitted']

const FILTER_OF_OPTION: Record<
  Exclude<SubmissionStatusFilterOption, 'all'>,
  SubmissionStatusFilter
> = {
  actionRequired: SubmissionStatusFilter.ACTION_REQUIRED,
  unsubmitted: SubmissionStatusFilter.UNSUBMITTED,
  waiting: SubmissionStatusFilter.WAITING,
  submitted: SubmissionStatusFilter.SUBMITTED,
}

/**
 * 「すべて」は全カード (提出計画なし = NOT_CREATED 含む)。それ以外は区分が一致する
 * カードだけ (NOT_CREATED はどれにも入らない)。
 */
export function filterCardsByStatus(
  cards: readonly PlanTypeCard[],
  option: SubmissionStatusFilterOption,
): readonly PlanTypeCard[] {
  if (option === 'all') {
    return cards
  }
  return cards.filter(
    (card) => card.submissionStatusFilter === FILTER_OF_OPTION[option],
  )
}

/** backend が数えた件数を選択肢へ写すだけ (「すべて」はエリアの全カード数)。 */
export function countOfOption(
  counts: SubmissionStatusFilterCounts | undefined,
  option: SubmissionStatusFilterOption,
): number | undefined {
  if (counts === undefined) {
    return undefined
  }
  return counts[option]
}
